/**
 * Генерирует список таймзон, форматирует их как "(GMT+03:00) Region/City"
 * и сортирует от Запада к Востоку.
 */
function getBrowserTimezones() {
  if (typeof Intl === 'undefined' || !Intl.supportedValuesOf) {
    console.warn("Intl API is not supported in this environment");
    return [];
  }

  const timezones = Intl.supportedValuesOf('timeZone');
  const now = new Date();

  // Форматтер для получения строки смещения (GMT+...)
  const offsetFormatter = new Intl.DateTimeFormat("en-US", {
    timeZoneName: "longOffset",
    hour12: false
  });

  const list = timezones.map(tz => {
    // Вычисляем смещение в минутах для сортировки
    // Создаем дату в этой зоне и сравниваем с UTC датой
    const dateString = new Date().toLocaleString("en-US", { timeZone: tz });
    const dateInTz = new Date(dateString);
    const dateInUtc = new Date(new Date().toLocaleString("en-US", { timeZone: "UTC" }));
    const offsetMinutes = (dateInTz - dateInUtc) / 60000;

    // Формируем красивую подпись
    // Получаем части даты, находим timeZoneName (напр. "GMT+02:00")
    const parts = offsetFormatter.formatToParts(now); // используем now, чтобы браузер учел таймзону
    // НО! Нам нужно форматировать now именно в целевой таймзоне tz
    const partsInTz = new Intl.DateTimeFormat("en-US", {
      timeZone: tz,
      timeZoneName: "longOffset",
      hour12: false
    }).formatToParts(now);

    const offsetPart = partsInTz.find(p => p.type === "timeZoneName");
    const offsetString = offsetPart ? offsetPart.value : "GMT";

    return {
      value: tz,
      text: `(${offsetString}) ${tz}`,
      offset: offsetMinutes
    };
  });

  // Сортировка
  return list.sort((a, b) => a.offset - b.offset);
}

/**
 * Принимает JSON-конфиг SurveyJS, находит вопрос "timezone",
 * заполняет choices и выставляет defaultValue.
 * Возвращает модифицированный конфиг.
 */
export function applyTimezoneLogic(surveyConfig) {
  // 1. Делаем глубокую копию конфига, чтобы не мутировать исходник
  const config = JSON.parse(JSON.stringify(surveyConfig));

  // 2. Получаем данные
  const timezoneList = getBrowserTimezones();
  const userCurrentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  if (timezoneList.length === 0) return config;

  // 3. Рекурсивная функция для поиска вопроса по имени (на случай вложенных панелей)
  function findQuestionByName(elements, name) {
    if (!elements) return null;

    for (const el of elements) {
      if (el.name === name) return el;
      // Если элемент - это панель, ищем внутри неё
      if (el.elements) {
        const found = findQuestionByName(el.elements, name);
        if (found) return found;
      }
    }
    return null;
  }

  // 4. Проходим по всем страницам
  let targetQuestion = null;
  if (config.pages) {
    for (const page of config.pages) {
      targetQuestion = findQuestionByName(page.elements, "timezone");
      if (targetQuestion) break;
    }
  }

  // 5. Если вопрос найден, обновляем его
  if (targetQuestion) {
    // Заполняем список
    targetQuestion.choices = timezoneList.map(item => ({
      value: item.value,
      text: item.text
    }));

    // Устанавливаем дефолтное значение
    // Проверяем, есть ли текущая зона пользователя в списке (на всякий случай)
    const isTzInList = timezoneList.some(item => item.value === userCurrentTimezone);

    if (isTzInList) {
      targetQuestion.defaultValue = userCurrentTimezone;
    } else {
      // Если браузер вернул экзотическую зону, которой нет в supportedValuesOf,
      // добавляем её принудительно, чтобы поле не было пустым
      targetQuestion.choices.push({ value: userCurrentTimezone, text: userCurrentTimezone });
      targetQuestion.defaultValue = userCurrentTimezone;
    }
  }

  return config;
}